import { useState } from "react";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import { useParams } from "react-router-dom";
import historyIcon from "../../assets/images/history-icon.svg";
import Table, { Column } from "../../Components/Tables/Table";
import { checkInDetailsData, HistoryLayoutDataPurchaseOrderDetails } from "../../Data/testData";
import PageHeader from "../../Layout/PageHeader";
import HistoryLayout from "../../Layout/HistoryLaout";
import DynamicDetailGrid from "../../Components/Grid/DynamicDetailGrid";

export default function PurchaseOrderDetails() {
  const { id } = useParams<{ id: string }>();
  const pageName = " Purchase Order(20158) ";
  const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };

  const [isShowCanvas, setShowCanvas] = useState(false);
  const handelCanvas = () => {
   setShowCanvas(!isShowCanvas);
  };
  const historyData = (
    <>
      <div
        className="d-flex justify-content-between w-100 align-items-center px-4"
        onClick={handelCanvas}
      >
        <div>
          <h6 className="cursor-pointer m-0 d-flex align-items-center">
            <img src={historyIcon} className="me-2" />
            History
          </h6>
        </div>
      </div>
    </>
  );
  const columns: Column[] = [
    {
      name: "Line#",
      selector: (row: { Line: string }) => row.Line,
    },
    {
      name: "Item Code",
      selector: (row: { ItemCode: { imgSrc: string; text: string } }) => (
        <div>
          {row.ItemCode.imgSrc && (
            <img
              src={require(`../../assets/images/${row.ItemCode.imgSrc}`)}
              alt={row.ItemCode.text}
              style={{ width: "20px", marginRight: "8px" }}
            />
          )}
          {row.ItemCode.text}
        </div>
      ),
    },
    {
      name: "Item Description",
      selector: (row: { ItemDescription: string }) => row.ItemDescription,
    },
    {
      name: "UOM",
      selector: (row: { UOM: string }) => row.UOM,
    },
    {
      name: "Expected Qty",
      selector: (row: { ExpectedQty: string }) => row.ExpectedQty,
    },
    {
      name: "Unit Cost",
      selector: (row: { ReceivedQuantity: string }) => row.ReceivedQuantity,
    },
  ];

  const InboundPurchaseOrder = {
    PurchaseOrderExpanded: [
      { label: 'Reference', value: "10381311" },
      { label: 'Created On', value: "04/19/2023" },
      { label: 'Requested Delivery Date', value: "04/20/2023" },
      { label: 'Special Instructions', value: (
        <>
        Handle with care  dummy text... <span className="text-primary ">(View More)</span>
        </>
      ) },
      { label: 'Status', value: (
          <>
            <div className="border border-primary rounded px-4 fs-11 w-auto d-inline-block">
              Open
            </div>
          </>
        )
      },
      { label: 'Attachment', value: "Sample.pdf" },
    ],

    ReturnPutawayDefault: [
      { label: 'Supplier', value: "John Smith" },
      { label: 'Warehouse', value: "East Houston" },
      { label: 'Created On', value: "19/04/2023" }
    ]
  }

  return (
    <>
      <PageHeader
        addUrl="/inbound/asn/overview/add"
        listUrl="/inbound/purchase-order"
        viewType={true}
        isHistoryEnabled={true}
        historyData={[historyData]}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded px-2">
        <div className="checkin-details col-12 bg-white col-12 px-2">
            {collapseStates[0] ? (
              <div className=" d-flex justify-content-between px-2 ">
                <DynamicDetailGrid customClassName="my-2 col-10" isExpandable={false} columns={3} data={InboundPurchaseOrder.ReturnPutawayDefault} />
                <div className="col-2">
                <div className="align-self-center d-flex flex-row-reverse my-4">
                  <span
                    className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                    onClick={() => toggleCollapse(0)}
                  >
                    {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
                  </span>
                </div>
              </div>
              </div>
            ) : (
              <div className="checkin-details flex-column-reverse align-items-center d-flex bg-white px-5 pe-3">
                <div className="d-flex col-12 py-4">
                <div className="d-flex col">
                  <DynamicDetailGrid customClassName="mb-2 pt-0 col" isExpandable={false} columns={2} data={InboundPurchaseOrder.PurchaseOrderExpanded} />
                </div>
                <div className="col d-flex flex-column justify-content-start align-items-end">
                  <div className="supplier position-relative px-4 py-3 mb-5">
                    <div className="floating-label fs-14 inbound-checkin-supplier position-absolute translate-middle px-2 bg-white">
                      Supplier
                    </div>
                    <div className="name">John Smith</div>
                    <div className="address mt-2">
                      Ship to address 1 <br />
                      Ship to address 2 <br />
                      City, State, Zip Code Country
                    </div>
                  </div>
                </div>
                <div className="col-1 ms-3">
                  <div className="align-self-center d-flex flex-row-reverse">

                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                      onClick={() => toggleCollapse(0)}
                    >
                      {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            )}
            </div>
          {/* <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"
              onClick={() => toggleCollapse(0)}
            >
              {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div> */}
        
        {/* {collapseStates[0] ? (
          // <div className="wrapper d-flex rounded-3 py-1 px-5">
          <div className="checkin-details d-flex bg-white col-12 py-1 pb-4 px-5 justify-content-between">
            <div className="col-auto ">
              <div className="PO mb-3">
                <label className="label-light-grey fs-14 fw-medium">Reference</label>
                <br />
                <label className="text-primary">10381311</label>
              </div>

              <div className="ExpectedDate mb-3">
                <label className="label-light-grey fs-14 fw-medium">
                  Requested Delivery Date
                </label>
                <br />
                <label className="">04/20/2023</label>
              </div>
              <div className="Status mb-3">
                <label className="label-light-grey fs-14 fw-medium">Status</label>
                <br />
                <label className="inbound-checkin-status px-2 fs-11">
                  Open
                </label>
              </div>
            </div>
            <div className="col-4 ">
              <div className="Reference1 mb-3">
                <label className="label-light-grey fs-14 fw-medium">Created On</label>
                <br />
                <label className="">04/19/2023</label>
              </div>
              <div className="SpecialInstructions mb-3">
                <label className="label-light-grey fs-14 fw-medium">
                  Special Instructions
                </label>
                <br />
                <label className="">
                  Handle with care dummy text of the printing and typesetting
                  industry. Lorem Ipsum has been the (
                  <span className="text-accent-blue fs-14">View More</span> )
                </label>
              </div>
              <div className="CarrierName mb-3">
                <label className="label-light-grey fs-14 fw-medium">Attachment</label>
                <br />
                <label className="">Sample.pdf</label>
              </div>
            </div>
            <div className="col-auto">
              <div className="supplier position-relative px-4 py-3 mb-5">
                <div className="floating-label fs-14 inbound-checkin-supplier position-absolute translate-middle px-2 bg-white">
                  Supplier
                </div>
                <div className="name">John Smith</div>
                <div className="address mt-2">
                  Ship to address 1 <br />
                  Ship to address 2 <br />
                  City, State, Zip Code Country
                </div>
              </div>
            </div>
          </div>
        ) : (
          // </div>
          <></>
        )} */}
      </div>
      <div className="my-2 bg-white rounded py-1 px-2">
        <Table
          columns={columns}
          data={checkInDetailsData}
          CheckboxStatus={false}
        />
      </div>

      <HistoryLayout isShowCanvas={isShowCanvas} handelCanvas={handelCanvas} />
      </>
  );
}
